<template>
  <div class="not-found-page">
    <van-empty image="error" description="页面暂不可用">
      <van-button size="small" type="primary" color="#2e8b7a" @click="goHome">返回首页</van-button>
    </van-empty>
  </div>
</template>

<script>
export default {
    name: 'NotFound',
    methods: {
        goHome () {
            this.$router.replace('/');
        }
    }
};
</script>

<style lang="sass" scoped>
.not-found-page
    min-height: 100vh
    display: flex
    align-items: center
    justify-content: center
    background: #f7faf9
</style>
